import React from 'react';
import ModalV1 from '../modal-v1/index';
import { ParkSalesContent } from './park-sales-content';

type ParkSaleModalProps = {
	show: boolean;
	onClose: () => void;
};

export const ParkSaleModal = ({ show, onClose }: ParkSaleModalProps) => {
	return (
		<ModalV1
			classes={{ content: 'z-[500]' }}
			show={show}
			onClose={onClose}
			headerAction={<div className="text-base font-semibold text-gray-900">Park Sale</div>}
		>
			<ParkSalesContent onClose={onClose} />
		</ModalV1>
	);
};

export default ParkSaleModal;
